import client from "./base"

export const getStatisticsPharmacies = async (params: any) => {
    const { adminId, limit, offset, search, category } = params

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/product-stats/pharmacies?limit=${limit}&offset=${offset}&search=${search}&category=${category}`

    try {
        let fetchResults = await client.get(path)
        let data: any = fetchResults.data
        return {
            data
        }
    } catch (err) {
        console.error("error on fetch inv items: ", err);
        return {
            data: []
        }
    }
}

export const getStatisticsPharmaciesExport = async (params: any) => {
    const { adminId, category } = params

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/product-stats/pharmacies-export?category=${category}`

    try {
        let fetchResults = await client.get(path)
        let data: any = fetchResults.data
        return {
            data
        }
    } catch (err) {
        console.error("error on fetch inv items: ", err);
        return {
            data: []
        }
    }
}

export const getStatisticsPharmaciesCount = async (params: any) => {
    const { adminId, search, category } = params

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/product-stats/pharmacies/count?search=${search}&category=${category}`

    try {
        let fetchResults = await client.get(path)
        let data: any = fetchResults.data
        return {
            data
        }
    } catch (err) {
        console.error("error on fetch inv items: ", err);
        return {
            data: {}
        }
    }
}

export const getStatisticsPrice = async (params: any) => {
    const { adminId, limit, offset, search, category } = params

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/product-prices?limit=${limit}&offset=${offset}&search=${search}&category=${category}`

    try {
        let fetchResults = await client.get(path)
        let data: any = fetchResults.data
        return {
            data
        }
    } catch (err) {
        console.error("error on fetch inv items: ", err);
        return {
            data: []
        }
    }
}

export const getStatisticsPriceExport = async (params: any) => {
    const { adminId, category } = params

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/product-prices-export?category=${category}`

    try {
        let fetchResults = await client.get(path)
        let data: any = fetchResults.data
        return {
            data
        }
    } catch (err) {
        console.error("error on fetch inv items: ", err);
        return {
            data: []
        }
    }
}

export const getStatisticsPriceCount = async (params: any) => {
    const { adminId, search, category } = params

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/product-prices/count?search=${search}&category=${category}`

    try {
        let fetchResults = await client.get(path)
        let data: any = fetchResults.data
        return {
            data
        }
    } catch (err) {
        console.error("error on fetch inv items: ", err);
        return {
            data: {}
        }
    }
}